import {
  ADD_PAGE_CONTENT,
  UPDATE_PAGE_CONTENT
} from "shared/constants/appConstants";
import Resources from "./resourcesActions";

export class BaseSubLineItemResource extends Resources {}

export class LineItemResource extends Resources {
  toggle(lineItemId, value) {
    return new Promise(resolve => {
      this.dispatch({
        type: ADD_PAGE_CONTENT,
        payload: { line_item_activation: { [lineItemId]: value } }
      });
      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  }

  activate(lineItemId) {
    return this.toggle(lineItemId, true);
  }

  deactivate(lineItemId) {
    return this.toggle(lineItemId, false);
  }

  get() {
    return new Promise(resolve => {
      this.dispatch({
        type: UPDATE_PAGE_CONTENT,
        payload: { line_item_activation: {} }
      });
      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  }
}
